import { takeLatest, all, call, put } from 'redux-saga/effects';
import { GET_ALL_REGIONS } from 'actions/regions/constants';
import {
  getAllRegionsSuccess,
  getAllRegionsError
} from 'actions/regions/regions';
import { fetchRegions } from 'services/api/regionsApi';

export function* getAllRegionsSaga() {
  try {
    const data = yield call(fetchRegions);
    yield put(getAllRegionsSuccess(data.data.data));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    yield put(getAllRegionsError());
  }
}

export function* getAllRegionsWatcher() {
  yield takeLatest(GET_ALL_REGIONS, getAllRegionsSaga);
}

export default function* rootSaga() {
  yield all([call(getAllRegionsWatcher)]);
}
